var _defs, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCircles = function SvgCircles(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215.894,
    height: 78.641,
    viewBox: "0 0 215.894 78.641",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.878,
    y1: 0.838,
    x2: 0.18,
    y2: 0.142,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12504",
    "data-name": "Group 12504",
    transform: "translate(84.215 10.642)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(20.424 0)",
    opacity: 0.07,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 131.679, 2.299)",
    opacity: 0.07,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    transform: "translate(-82.017 -3.915) rotate(2)",
    opacity: 0.05,
    fill: "url(#linear-gradient)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircles, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjE1Ljg5NCIgaGVpZ2h0PSI3OC42NDEiIHZpZXdCb3g9IjAgMCAyMTUuODk0IDc4LjY0MSI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuODc4IiB5MT0iMC44MzgiIHgyPSIwLjE4IiB5Mj0iMC4xNDIiIGdyYWRpZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmZmIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIwIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfMTI1MDQiIGRhdGEtbmFtZT0iR3JvdXAgMTI1MDQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg0LjIxNSAxMC42NDIpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNDIzIiBkYXRhLW5hbWU9IkVsbGlwc2UgNDIzIiBjeD0iMzQiIGN5PSIzNCIgcj0iMzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjQyNCAwKSIgb3BhY2l0eT0iMC4wNyIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzQyNyIgZGF0YS1uYW1lPSJFbGxpcHNlIDQyNyIgY3g9IjI1IiBjeT0iMjUiIHI9IjI1IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIDAuOTY2LCAtMC45NjYsIC0wLjI1OSwgMTMxLjY3OSwgMi4yOTkpIiBvcGFjaXR5PSIwLjA3IiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNDI4IiBkYXRhLW5hbWU9IkVsbGlwc2UgNDI4IiBjeD0iMzEuNSIgY3k9IjMxLjUiIHI9IjMxLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04Mi4wMTcgLTMuOTE1KSByb3RhdGUoMikiIG9wYWNpdHk9IjAuMDUiIGZpbGw9InVybCgjbGluZWFyLWdyYWRpZW50KSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };